import CategoryType from 'owa-service/lib/contract/CategoryType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

/**
 * Get the list of categories (each category having name, category color and id) from user's configuration
 */
export const getMasterCategoriesFromUserConfig = (): CategoryType[] => {
    const userConfig = getUserConfiguration();
    const masterCategoryList = userConfig.MasterCategoryList;
    return masterCategoryList?.MasterList || ([] as any);
};
